/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(html: any) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
